import React, { useReducer, useState } from 'react';
import { sendTicketEmail } from '../services/emailService';
import jsPDF from 'jspdf';
import './Ticket.css';

const aplicacionesDisponibles = [
  "Gestión Sage 200",
  "Finanzas Sage 200",
  "Proyectos Sage 200",
  "Producción Sage 200",
  "App Partes",
  "App Josemite",
  "App Compras",
  "App Validador",
];

// Estado inicial para el formulario
const initialState = {
  empresa: '',
  telefono: '',
  email: '',
  contactarCon: '',  // Nuevo campo agregado
  aplicacion: '',
  llamarHorario: '',
  motivo: ''
};

// Reducer para manejar los cambios en el formulario
const reducer = (state, action) => ({
  ...state,
  [action.field]: action.value
});

// Funciones de validación
const validateEmail = (email) => /\S+@\S+\.\S+/.test(email);
const validatePhone = (phone) => /^[0-9]{9,15}$/.test(phone);

// Componente para campos de entrada (input)
const InputField = ({ label, type, name, value, onChange, required }) => (
  <label>
    {label}:
    <input 
      type={type} 
      name={name} 
      value={value} 
      onChange={onChange} 
      required={required} 
    />
  </label>
);

// Componente para campos de selección (select)
const SelectField = ({ label, name, value, onChange, options }) => (
  <label>
    {label}:
    <select 
      name={name} 
      value={value} 
      onChange={onChange} 
      required
    >
      <option value="">Selecciona una opción...</option>
      {options.map((option, index) => (
        <option key={index} value={option}>{option}</option>
      ))}
    </select>
  </label>
);

const TicketPage = () => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Manejo de cambios en los campos del formulario
  const handleChange = (e) => {
    dispatch({ field: e.target.name, value: e.target.value });
  };

  const generarPDF = () => {
    const doc = new jsPDF();

    doc.setFontSize(18);
    doc.text("Ticket de Soporte", 10, 20);

    doc.setFontSize(12);
    doc.text(`Empresa: ${state.empresa}`, 10, 30);
    doc.text(`Teléfono: ${state.telefono}`, 10, 40);
    doc.text(`Email: ${state.email}`, 10, 50);
    doc.text(`Aplicación: ${state.aplicacion}`, 10, 60);
    doc.text(`Horario para llamar: ${state.llamarHorario}`, 10, 70);
    doc.text(`Motivo: ${state.motivo}`, 10, 80);
    doc.text(`Contactar con: ${state.contactarCon}`, 10, 90);

    doc.save("ticket_soporte.pdf");
  };

  // Función para manejar el envío del formulario
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateEmail(state.email)) {
      setError("Email no válido");
      setSuccessMessage('');
      return;
    }
    if (!validatePhone(state.telefono)) {
      setError("Teléfono no válido (solo números, mínimo 9 dígitos)");
      setSuccessMessage('');
      return;
    }

    setError('');
    setIsSubmitting(true);
    setSuccessMessage('');

    const nuevoTicket = `Ticket${Math.floor(100000 + Math.random() * 900000)}`;

    try {
      await sendTicketEmail(
        state.empresa,
        state.telefono,
        state.email,
        state.aplicacion,
        state.llamarHorario,
        state.motivo,
        state.contactarCon,
        nuevoTicket
      );

      setSuccessMessage(`Se ha abierto el ticket número ${nuevoTicket} correctamente.`);
      generarPDF(); // Generar y descargar el PDF
    } catch (error) {
      setError('Error al enviar el ticket. Intenta nuevamente.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="contacto">
      <div className="contacto-background">
        <img 
          src="/images/ticketbackground.jpg"
          alt="Imagen de fondo de contacto"
        />
      </div>
      <div className="ticket-container">
        <h1>Crear Ticket</h1>
        <form onSubmit={handleSubmit} className="ticket-form">
          <fieldset>
            <legend>Información del Cliente</legend>
            <InputField 
              label="Empresa" 
              type="text" 
              name="empresa" 
              value={state.empresa} 
              onChange={handleChange} 
              required 
            />
            <InputField 
              label="Teléfono" 
              type="tel" 
              name="telefono" 
              value={state.telefono} 
              onChange={handleChange} 
              required 
            />
            <InputField 
              label="Email" 
              type="email" 
              name="email" 
              value={state.email} 
              onChange={handleChange} 
              required 
            />
            <InputField  // Nuevo campo agregado
              label="Contactar con" 
              type="text" 
              name="contactarCon" 
              value={state.contactarCon} 
              onChange={handleChange} 
              required={false} 
            />
          </fieldset>

          <fieldset>
            <legend>Detalles del Ticket</legend>
            <SelectField 
              label="Aplicación" 
              name="aplicacion" 
              value={state.aplicacion} 
              onChange={handleChange} 
              options={aplicacionesDisponibles} 
            />
            <InputField 
              label="Llamar en horario de" 
              type="text" 
              name="llamarHorario" 
              value={state.llamarHorario} 
              onChange={handleChange} 
            />
            <label>
              Motivo de la incidencia:
              <textarea 
                name="motivo" 
                value={state.motivo} 
                onChange={handleChange} 
                required 
                className="no-resize"
              />
            </label>
          </fieldset>

          <button type="submit" disabled={isSubmitting}>
            {isSubmitting ? 'Enviando...' : 'Abrir Ticket'}
          </button>
        </form>

        {/* Mensajes de error o éxito */}
        {error && <p className="error-message">{error}</p>}
        {successMessage && <p className="success-message">{successMessage}</p>}
      </div>
    </div>
  );
};

export default TicketPage;